import { FC, useContext } from "react";
import { Button, Modal, ModalProps } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "src/context/authContext";

type ShowCopayModalProps = ModalProps & {
  patientCount?: number;
};

const ShowCopayModal: FC<ShowCopayModalProps> = ({
  patientCount = 0,
  ...props
}): JSX.Element => {

  const { userData } = useContext(AuthContext);
  const location = useLocation();
  const handleClose = () => {
    props.onHide?.();
  };
  const handleClickHere = () => {
    handleClose()
    localStorage.setItem("loginModalShown", "false");
  // Example actions
  // setIsModalOpen(false)
  // trackEvent("copay_link_clicked")
};

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
         ACTION REQUIRED: CO-PAY CLAIM REMINDER
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
           You have {userData?.copay_remaining_days_count} patients who have 15 days or less remaining to file a co-pay claim for ZILRETTA. Please
          <Link to={{
            pathname: "/pages/copay/claim",
            search: "isFromModal:true",
          }}
          onClick={handleClickHere}
          > click here </Link>
          to review Co-pay Cases Tab for more details.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShowCopayModal;
